import React, { lazy, useEffect, useState } from "react";
import { connect } from "react-redux";

import AppRoute from "./route";
import PageHeader from "../components/pageHeader";
import Footer from "../container/layout/footer";
import GoToTop from "../components/goToTop";

// ---------- Routes ---------- //
const HomePage = lazy(() => import("../pages/homePage"));
const AcademyPage = lazy(() => import("../pages/academyPage/aboutBIPARD"));
const About = lazy(() => import("../pages/academyPage/aboutBIPARD"));
const Vision = lazy(() => import("../pages/academyPage/aboutBIPARD/vision"));
const Objective = lazy(() => import("../pages/academyPage/aboutBIPARD/objective"));
const GeneralCouncil = lazy(() => import("../pages/academyPage/governance/generalCouncil"));
const MoA = lazy(() => import("../pages/academyPage/governance/memorandumOfAssociation"));
const Team = lazy(() => import("../pages/academyPage/team"));
const KnowledgePartner = lazy(() => import("../pages/academyPage/knowledgePartner"));
const Gallery = lazy(() => import("../pages/academyPage/gallery"));
const DGMessage = lazy(() => import("../pages/academyPage/dgMessage"));
const DGReview = lazy(() => import("../pages/academyPage/dgReview"));
const TrainingCenter = lazy(() => import("../pages/academyPage/facilities/trainingCenter"));
const SmartClassroom = lazy(() => import("../pages/academyPage/facilities/smartClassroom"));
const ComputerLab = lazy(() => import("../pages/academyPage/facilities/computerLab"));
const Hostel = lazy(() => import("../pages/academyPage/facilities/hostel"));
const DinningHall = lazy(() => import("../pages/academyPage/facilities/dinningHall"));
const Sports = lazy(() => import("../pages/academyPage/facilities/sports"));
const Yoga = lazy(() => import("../pages/academyPage/facilities/yoga"));
const Healthcare = lazy(() => import("../pages/academyPage/facilities/healthCare"));
const Magazine = lazy(() => import("../pages/publicationPage/magazine"));
const ReadyReckoner = lazy(() => import("../pages/publicationPage/readyReckoner"));
const eBooks = lazy(() => import("../pages/publicationPage/eBooks"));
const TrainingCalendar = lazy(() => import("../pages/trainingPage/trainingCalendar"));
const TrainingHistory = lazy(() => import("../pages/trainingPage/trainingHistory"));
const TrainingRules = lazy(() => import("../pages/trainingPage/trainingRules"));
const CCTExamPage = lazy(() => import("../pages/examinationPage/cctExamPage"));
const DepartmentalExamPage = lazy(() => import("../pages/examinationPage/departmentalExamPage"));
const OtherPage = lazy(() => import("../pages/examinationPage/otherPage"));
const MessClubPage = lazy(() => import("../pages/clubsPage/messClub"));
const ProtocolClubPage = lazy(() => import("../pages/clubsPage/protocolClub"));
const SportsClubPage = lazy(() => import("../pages/clubsPage/sportsClub"));
const AcademicClubPage = lazy(() => import("../pages/clubsPage/academicClub"));
const AdventureClubPage = lazy(() => import("../pages/clubsPage/adventureClub"));
const BharatDarshanClubPage = lazy(() => import("../pages/clubsPage/bharatDarshanClub"));
const DocumentationClubPage = lazy(() => import("../pages/clubsPage/documentationClub"));
const SanskritiClubPage = lazy(() => import("../pages/clubsPage/sanskritiClub"));
const VisitUsPage = lazy(() => import("../pages/visitUsPage"));
const RTIPage = lazy(() => import("../pages/rtiPage"));
const NotificationPage = lazy(() => import("../pages/notificationPage"));
const ArchiveNotificationPage = lazy(() => import("../pages/notificationPage/archiveNotification"));


const openRoutes = [
    { path: "/", exact: true, component: HomePage },
    { path: "/academy", exact: true, component: AcademyPage },
    { path: "/academy/about", exact: true, component: About },
    { path: "/academy/about/vision", exact: true, component: Vision },
    { path: "/academy/about/objective", exact: true, component: Objective },
    { path: "/academy/governance/generalcouncil", exact: true, component: GeneralCouncil },
    { path: "/academy/governance/MoA", exact: true, component: MoA },
    { path: "/academy/team", exact: true, component: Team },
    { path: "/academy/knowledgepartner", exact: true, component: KnowledgePartner },
    { path: "/academy/gallery", exact: true, component: Gallery },
    { path: "/academy/DGMessage", exact: true, component: DGMessage },
    { path: "/academy/DGReview", exact: true, component: DGReview },
    { path: "/academy/facilities/trainingcenter", exact: true, component: TrainingCenter },
    { path: "/academy/facilities/smartclassroom", exact: true, component: SmartClassroom },
    { path: "/academy/facilities/computerlab", exact: true, component: ComputerLab },
    { path: "/academy/facilities/hostel", exact: true, component: Hostel },
    { path: "/academy/facilities/dinninghall", exact: true, component: DinningHall },
    { path: "/academy/facilities/sports", exact: true, component: Sports },
    { path: "/academy/facilities/yoga", exact: true, component: Yoga },
    { path: "/academy/facilities/healthCare", exact: true, component: Healthcare },
    { path: "/publication/magazine", exact: true, component: Magazine },
    { path: "/publication/ready-reckoner", exact: true, component: ReadyReckoner },
    { path: "/publication/eBooks", exact: true, component: eBooks },
    { path: "/training/trainingcalendar", exact: true, component: TrainingCalendar },
    { path: "/training/traininghistory", exact: true, component: TrainingHistory },
    { path: "/training/trainingrules", exact: true, component: TrainingRules },
    { path: "/examination/cctexam", exact: true, component: CCTExamPage },
    { path: "/examination/departmentalexam", exact: true, component: DepartmentalExamPage },
    { path: "/examination/otherexam", exact: true, component: OtherPage },
    { path: "/clubs/messclub", exact: true, component: MessClubPage },
    { path: "/clubs/documentationclub", exact: true, component: DocumentationClubPage },
    { path: "/clubs/protocolclub", exact: true, component: ProtocolClubPage },
    { path: "/clubs/sportsclub", exact: true, component: SportsClubPage },
    { path: "/clubs/sanskriticlub", exact: true, component: SanskritiClubPage },
    { path: "/clubs/academicclub", exact: true, component: AcademicClubPage },
    { path: "/clubs/adventureclub", exact: true, component: AdventureClubPage },
    { path: "/clubs/bharatdarshanclub", exact: true, component: BharatDarshanClubPage },
    { path: "/visitus", exact: true, component: VisitUsPage },
    { path: "/RTI", exact: true, component: RTIPage },
    { path: "/notification", exact: true, component: NotificationPage },
    { path: "/notification/archive", exact: true, component: ArchiveNotificationPage },

];

const authRoutes = [];
const PagesRoute = (props) => {
    const [allRoutes, setAllRoutes] = useState([])

    const user = { 'superadmin': 'superadmin', 'admin': 'admin' }
    const [userType, setUserType] = useState(user)
    // useEffect(() => {
    //     setAllRoutes([...authRoutes])
    //     if (props?.auth?.authDetails?.data?.token) {
    //         setAllRoutes([...authRoutes])
    //     }
    //     else {
    //         setAllRoutes([...openRoutes])
    //     }
    //     // setUserType(user.admin)
    // }, [props?.auth?.authDetails?.data])
    
    useEffect(() => {
        setAllRoutes([...openRoutes])
    }, [])


    return (
        <>
            <PageHeader/>
            {openRoutes.map((route, idx) => (
                <AppRoute path={route.path} component={route.component} key={idx} isAuthProtected={true} />
            ))}
            <GoToTop/>
            <Footer/>
        </>

    );
};


const mapStateToProps = (state) => {
    return {
        auth: state.Auth,
    }
}

export default connect(mapStateToProps, null)(PagesRoute);

